import { render, staticRenderFns } from "./FilterPostWrapper.vue?vue&type=template&id=0f9ab205&"
import script from "./FilterPostWrapper.vue?vue&type=script&lang=ts&"
export * from "./FilterPostWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./FilterPostWrapper.vue?vue&type=style&index=0&id=0f9ab205&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports